import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';

import { showToast } from '@app/providers/ToastProvider';

import configRequest from '../configRequest';

export interface AMODownloadApplicationData {
	application_id: number;
}

export type AMODownloadApplicationResponse = Blob;

const downloadApplication = configRequest<AMODownloadApplicationResponse, AMODownloadApplicationData>({
	requestPrefix: 'amo/applications/downloadApplication',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.DOWNLOAD_APPLICATION(),
		method: HTTP_METHODS_ENUM.POST,
		data,
		responseType: 'blob',
	}),
	onSuccess: () => showToast.success('Application has been downloaded successfully'),
});

export default downloadApplication;
